import { style, media } from "typestyle";
import { colors, queries } from "styles/styles";
import { CSSObjectWithLabel } from "react-select";

export const row = style(
  {
    display: "flex",
    flexDirection: "column",

    $nest: {
      "&>div": {
        marginBottom: "1rem",
      },
    },
  },
  media(queries.medium, {
    flexDirection: "row",
    marginBottom: "3rem",

    $nest: {
      "&>div": {
        marginBottom: 0,
        $nest: {
          "&:first-child": {
            marginRight: "2rem",
          },
        },
      },
    },
  }),
);

export const phoneNumberInput = style({
  display: "flex",
  border: `2.5px solid ${colors.hooplaPurple}`,
  borderRadius: "9px",
  width: "100%",
  background: colors.hooplaWhite,
  alignItems: "center",
  boxSizing: "border-box",
  minHeight: "60px",
  $nest: {
    "&:disabled": {
      color: colors.grey_20,
    },
    "&>div>button": {
      border: "0 !important",
      borderRight: "1px solid rgba(0,0,0,0.2) !important",
      padding: "0px 4px",
      flex: 1,
    },
    "&>input": {
      border: "0 !important",
      flex: "1 0 auto !important",
      fontSize: "18px !important",
      background: "transparent",
      outline: "none !important",
    },
  },
});

export const phoneInput = style({
  flex: 1,
  padding: "26px 12px !important",
});
export const countrySelector = style({});

export { labeledInput } from "components/Input/styles";

export const footer = style(
  {
    display: "flex",
    alignItems: "center",
    marginBottom: "3rem",
    flexDirection: "column",
  },
  media(queries.medium, {
    flexDirection: "row",
  }),
);

export const error = style({
  flex: 1,
});

export const actions = style(
  {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column-reverse",
    marginTop: "1rem",
    $nest: {
      button: {
        marginBottom: "1rem",
      },
    },
  },
  media(queries.medium, {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: 0,

    $nest: {
      button: {
        marginBottom: 0,
        marginLeft: "2rem",
      },
    },
  }),
);

/*
          countrySelectorStyleProps={{
            className:
              "[&>button]:min-h-[50px] [&>button]:p-3 [&>button]:!border-solid [&>button]:!border-jupiter [&>button]:!border [&>button]:!bg-jupiter [&>button]:!bg-opacity-[16%] [&>button]:!outline-none group-has-[:focus]:[&>button]:!border-cornflower-blue [&>button]:!rounded-l-md",
          }}
          inputClassName={`!min-h-[50px] !border-solid !border-jupiter !border !p-3 !bg-jupiter !bg-opacity-[16%] !outline-none focus:!border-cornflower-blue !rounded-r-md !w-full !text-base`}
*/

export const selectStyles = {
  control: (styles: CSSObjectWithLabel) => ({
    ...styles,
    width: "7rem",
    backgroundColor: colors.hooplaBackground,
    border: `2.5px solid ${colors.hooplaPurple}`,
    borderRadius: "9px",
    height: "66px",
    marginRight: "0.5rem",
    fontSize: "22px",
  }),
  placeholder: (styles: CSSObjectWithLabel) => ({
    ...styles,
    marginLeft: "1rem",
  }),
  singleValue: () => ({
    color: colors.hooplaTextColor,
    marginLeft: "1rem",
  }),
  indicatorSeparator: () => ({}),
  option: (styles: CSSObjectWithLabel) => ({
    ...styles,
    backgroundColor: colors.hooplaBackground,
    color: colors.hooplaTextColor,
    ":hover": {
      backgroundColor: colors.hooplaBlue,
      cursor: "pointer",
    },
  }),
  menu: (styles: CSSObjectWithLabel) => ({
    ...styles,
    backgroundColor: colors.hooplaBackground,
  }),
  dropdownIndicator: (styles: CSSObjectWithLabel) => ({
    ...styles,
    color: colors.hooplaBlue,
    ":hover": {
      color: colors.hooplaGray,
    },
  }),
};
